import { createElement as e } from "react";
import { Switch, Route } from "react-router";
import Header from "../components/Header";
import ImpersonationContext from "../components/ImpersonationContext";
import { Navbar, Nav, Glyphicon } from "react-bootstrap";
import AccountNav from "../components/AccountNav";
import NavItemLink from "sc/ui/components/NavItemLink";
import EngineersSearch from "../pages/partner-tech/EngineersSearch";
import ScheduleStatus from "../pages/partner-tech/ScheduleStatus";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";
import SchedulePage from "../pages/partner-tech/SchedulePage";
import ContactPage from "../pages/ContactPage";

const Menu = () =>
  e(
    Navbar.Collapse,
    { className: "pull-right" },
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { id: "engineers-menu-item", eventKey: "1", href: "/" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-home" }),
        " Engineers",
      ),
    ),
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { id: "scheduling-menu-item", eventKey: "2", href: "/scheduling" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-calendar" }),
        " Schedule",
      ),
    ),
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { id: "contact-menu-item", eventKey: "3", href: "/contact" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-envelope" }),
        " Contact",
      ),
    ),
    e(Nav, null, e(AccountNav)),
  );

export default () =>
  e(
    "div",
    null,
    e(Header, { MenuComponent: Menu }),
    e(ImpersonationContext),
    e(
      Switch,
      null,
      e(Route, { path: "/", component: EngineersSearch, exact: true }),
      e(Route, { path: "/scheduling", component: ScheduleStatus, exact: true }),
      e(Route, {
        path: "/schedule/:regionId",
        component: SchedulePage,
        exact: true,
      }),
      e(Route, { path: "/contact", component: ContactPage, exact: true }),
      e(Route, { path: "*", component: PageNotFound, exact: true }),
    ),
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/routes/PartnerTech.js